// Lightweight event bus for cross-component communication
// Usage: on(event, handler); off(event, handler); emit(event, payload)

const listeners = {};

export const on = (event, handler) => {
  if (!listeners[event]) listeners[event] = [];
  listeners[event].push(handler);
};

export const off = (event, handler) => {
  if (!listeners[event]) return;
  listeners[event] = listeners[event].filter((fn) => fn !== handler);
};

export const emit = (event, payload) => {
  (listeners[event] || []).forEach((fn) => {
    try { fn(payload); } catch (_) { /* no-op */ }
  });
};

export default { on, off, emit };
